<template>
  <v-container class="py-0 px-5">
    <v-row v-if="false">
      <pre>
        {{ componentEvent.component }}
      </pre>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <data-selector
          v-model="componentEvent.event_type_id"
          autofocus
          field-name="event_type_id"
          source-type="component-event-types"
          translate
        />
      </v-col>
    </v-row>
    <v-row v-if="componentEvent.event_type_id">
      <v-col
        v-if="componentEvent.event_type_id === 'cet_01'"
        cols="12"
      >
        <data-selector
          v-model="componentEvent.plane_id"
          field-name="reg_num"
          source-type="planes-maintenance"
        />
      </v-col>
      <v-col cols="6">
        <date-field
          v-model="componentEvent.event_start"
          field-name="event_start"
          rules="required|date"
        />
      </v-col>
      <v-col cols="6">
        <date-field
          v-model="componentEvent.event_end"
          field-name="event_end"
          rules="date"
        />
      </v-col>
      <v-col cols="12">
        <validated-text-field
          v-model="componentEvent.comment"
          field-name="comment"
          type="text"
        />
      </v-col>
      <v-col cols="12">
        <material-card
          color="accent"
          :title="$t('limitations')"
          class="mb-6 pa-2 card-block"
          fluid
          style="background-color: #eceff1"
        >
          <v-row v-if="componentEvent.component.date_limiter">
            <v-col cols="4">
              <div class="font-weight-bold text-h5">
                {{ $t('fields.date_limiter') }}
              </div>
              <div><b>{{ $t('current') }}:</b>{{ componentEvent.event_start }}</div>
              <div><b>{{ $t('recommended') }}:</b>{{ recommended_date }}</div>
            </v-col>
            <v-col cols="8">
              <date-field
                v-model="componentEvent.limit_date"
                field-name="limit_date"
                rules="required|date"
              />
            </v-col>
          </v-row>
          <v-row v-if="componentEvent.component.takeoff_limiter">
            <v-col cols="4">
              <div class="font-weight-bold text-h5">
                {{ $t('fields.takeoff_limiter') }}
              </div>
              <b>{{ $t('current') }}:</b> {{ componentEvent.component.current_counter_takeoff }}<br>
              <b>{{ $t('recommended') }}:</b> {{ componentEvent.component.current_counter_takeoff + componentEvent.component.cycle_counter_takeoff }}
            </v-col>
            <v-col cols="8">
              <validated-text-field
                v-model="componentEvent.limit_counter_takeoff"
                field-name="limit_counter_takeoff"
                rules="required"
                type="number"
              />
            </v-col>
          </v-row>
          <v-row v-if="componentEvent.component.flight_limiter">
            <v-col cols="4">
              <div class="font-weight-bold text-h5">
                {{ $t('fields.flight_limiter') }}
              </div>
              <b>{{ $t('current') }}:</b> {{ componentEvent.component.current_counter_flight | minToTimeFormat }}<br>
              <b>{{ $t('recommended') }}:</b> {{ parseFloat(componentEvent.component.current_counter_flight) + (parseFloat(componentEvent.component.cycle_counter_flight)*60) | minToTimeFormat }}
            </v-col>
            <v-col cols="8">
              <validated-text-field
                v-model="componentEvent.limit_counter_flight"
                field-name="limit_counter_flight"
                rules="required"
                type="number"
              />
            </v-col>
          </v-row>
          <v-row v-if="componentEvent.component.engine_limiter">
            <v-col cols="4">
              <div class="font-weight-bold text-h5">
                {{ $t('fields.engine_limiter') }}
              </div>
              <b>{{ $t('current') }}:</b> {{ componentEvent.component.current_counter_engine }}<br>
              <b>{{ $t('recommended') }}:</b> {{ parseFloat(componentEvent.component.current_counter_engine) + parseFloat(componentEvent.component.cycle_counter_engine) }}
            </v-col>
            <v-col cols="8">
              <validated-text-field
                v-model="componentEvent.limit_counter_engine"
                field-name="limit_counter_engine"
                rules="required"
                type="number"
                step="0.01"
              />
            </v-col>
          </v-row>
        </material-card>
      </v-col>
    </v-row>
    <v-card-actions class="justify-center">
      <v-btn
        v-if="componentEvent.avatar_id !== null"
        :href="documentStorageUrl"
        icon
        target="_blank"
      >
        <v-icon>
          {{ '$show' }}
        </v-icon>
      </v-btn>
      <upload-files
        filter="document"
        source-type="document"
        :upload-params="componentEvent"
        class="mt-2"
        @success="uploaded"
      />
    </v-card-actions>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'EditComponentEvent',
    props: {
      componentEvent: Object,
    },
    computed: {
      today () { return moment().format('YYYY-MM-DD') },
      recommended_date () { return moment(this.componentEvent.event_start).add(this.componentEvent.component.cycle_date + 1, 'd').format('YYYY-MM-DD') },
      documentStorageUrl () {
        // return 'data:image/jpeg;base64,' + this.user.avatar.image
        return process.env.VUE_APP_API_URL + '/api/storage/' + this.componentEvent.storage_id
      },
    },
    methods: {
      uploaded (response) {
        this.componentEvent.storage_id = response.id
        console.log(response.id)
      },
    },
  }
</script>
